import { Component, effect, input, signal, OnInit, OnDestroy, computed } from '@angular/core';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [],
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent implements OnInit, OnDestroy {
  readonly title     = input('PRAXION');
  readonly isLoading = input(true);

  protected readonly fadeOut = signal(false);
  protected readonly hideMachinery = signal(false);
  protected readonly showText = signal(false);

  protected readonly titleLetters = computed(() => this.title().split(''));

  private timers: any[] = [];

  constructor() {
    effect(() => {
      this.fadeOut.set(!this.isLoading());
    });
  }

  ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    }

    // FASE 1: Ocultar la maquinaria
    const t1 = setTimeout(() => {
      this.hideMachinery.set(true);
    }, 2200);
    this.timers.push(t1);

    // FASE 2: Iniciar la animación letra por letra
    const t2 = setTimeout(() => {
      this.showText.set(true);
    }, 2600);
    this.timers.push(t2);
  }

  ngOnDestroy() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
    this.timers.forEach(t => clearTimeout(t));
  }
}

